/*------------------------------------*\
    MODULES
\*------------------------------------*/
import loadGoogleMapsApi from "load-google-maps-api";
import { debounce } from "debounce";

/*------------------------------------*\
    GOOGLE MAP
\*------------------------------------*/
class GoogleMap {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.map = null;
        self.markers = [];
        self.googleMapCenterLat = parseFloat(self.elem.getAttribute('data-origin-lat'));
        self.googleMapCenterLng = parseFloat(self.elem.getAttribute('data-origin-lng'));
        self.googleMapZoom = parseInt(self.elem.getAttribute('data-zoom'));
        self.googleMapMarkers = JSON.parse(self.elem.getAttribute('data-markers'));
        self.googleMap = self.elem.getAttribute('data-google-map');

        

        // Load Google Maps API
        loadGoogleMapsApi({ key: 'AIzaSyDZTMshtgIu9RDuWomAG903panzCIrejEg' })
            .then((googleMaps) => {
                self.init(googleMaps);
            })
            .catch((error) => {
                console.error('Error loading Google Maps API', error);
            });
    }

    init(googleMaps) {
        let self = this;

        // Map options
        const mapOptions = {
            center: { lat: self.googleMapCenterLat, lng: self.googleMapCenterLng }, // Initial center coordinates
            zoom: self.googleMapZoom, // Initial zoom level
        };

        // Create the map
        try {
            self.map = new googleMaps.Map(self.elem, mapOptions);
        } catch (error) {
          } finally {
            // Code here always runs. Doesn't matter if there was an error or not.
          }

 
        for (const googleMapMarker of self.googleMapMarkers) {
            self.addMarkerAtCoordinates({ 
                lat: parseFloat(googleMapMarker.markerLat), 
                lng: parseFloat(googleMapMarker.markerLng), 
                title: 'Marker Title',
                icon: { url: "/assets/images/svg/map-marker.svg" },
            
            });
        }

    }

    addMarker(markerOptions) {
        let self = this;

        if (!self.map) {
            return;
        }

        // Create a new marker
        const marker = new google.maps.Marker({
            map: self.map,
            ...markerOptions,
        });

        // Add the marker to the markers array
        self.markers.push(marker);
    }

    addMarkerAtCoordinates(coordinates) {
        let self = this;

        // Add a marker at the specified coordinates
        self.addMarker({
            position: coordinates,
            title: coordinates.title || '',
            icon: coordinates.icon || null,
        });
    }
}

export default GoogleMap;
